import React from 'react';
import { Card, Button } from '@dopomogai/ui';

type CTA = {
  text: string;
  onClick?: () => void;
  href?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
};

type Props = {
  title?: string;
  description?: string;
  cta?: CTA;
  className?: string;
};

export function EmptyState({
  title = 'No quotes yet',
  description = 'When you generate a quote, it will appear here.',
  cta,
  className,
}: Props) {
  return (
    <Card noHoverEffect className={className}>
      <div className="p-10 text-center">
        <p className="text-xl font-bold text-slate-900">{title}</p>
        <p className="text-slate-600 mt-2">{description}</p>
        {cta && (
          <div className="mt-6 flex justify-center">
            {cta.href ? (
              <a href={cta.href}>
                <Button text={cta.text} variant={cta.variant || 'primary'} />
              </a>
            ) : (
              <Button text={cta.text} variant={cta.variant || 'primary'} onClick={cta.onClick} />
            )}
          </div>
        )}
      </div>
    </Card>
  );
}
